<script>
export default {
    name: "ReceivedPaymentsReport",

    data() {

        return {
            filter: {
                search: ``,
                dateFrom: window.moment().format(`YYYY-MM-DD`),
                dateTo: window.moment().format(`YYYY-MM-DD`),
                pmode: ``,
                cashier: ``,
            },
            payments: [],
            users: [],
            paymentModes: [],
          userActivityModels: {
            userHostName: '',
            userHostAddress: '',
            userActivity: '',
            userName:  this.$root.username,
                
            }
        };
    },

    computed: {

 
totalPaidAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => 
                    payment.amount ? parseFloat(payment.amount) : 0)
                .reduce((amt, sum ) => amt+sum);
        },

        totalCreditAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => 
                    payment.creditAmount ? parseFloat(payment.creditAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalReceiptAmt() {
            if(!this.payments.length && !this.payments.billPaymentsReport) return 0;

            if(!this.payments.billPaymentsReport.length) return 0;

            return this.payments.billPaymentsReport.map(payment => 
                    payment.receiptAmount ? parseFloat(payment.receiptAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalDepositAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => 
                    dep.depositAmount ? parseFloat(dep.depositAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalAllocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => 
                    dep.amountAllocated ? parseFloat(dep.amountAllocated) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalUnallocatedAmt() {
            if(!this.payments.length && !this.payments.depositsReport) return 0;

            if(!this.payments.depositsReport.length) return 0;

            return this.payments.depositsReport.map(dep => 
                    dep.unAllocatedAmount ? parseFloat(dep.unAllocatedAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },

        totalCashOut() {

            if(!this.payments.length && !this.payments.cashReport ) return 0;

            if(!this.payments.cashReport.length) return 0;

            return this.payments.cashReport.map(cOut => cOut.amount ? parseFloat(cOut.amount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },
        totalSalesAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.totalAmount ? parseFloat(dep.totalAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },
        totalSalesPaidAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.paidAmount ? parseFloat(dep.paidAmount) : 0)
                .reduce((amt,sum ) => amt+sum);
        },totalSalesbalanceAmt() {
            if(!this.payments.length && !this.payments.salesReport) return 0;

            if(!this.payments.salesReport.length) return 0;

            return this.payments.salesReport.map(dep => 
                    dep.balance ? parseFloat(dep.balance) : 0)
                .reduce((amt,sum ) => amt+sum);
        },
        totalReceivedAmount() {

            return this.totalPaidAmt + this.totalDepositAmt+ this.totalSalesPaidAmt;
        },

        tillAmount() {

            return this.totalReceivedAmount - (this.totalCreditAmt + this.totalCashOut);
            // return this.totalReceivedAmount - (this.totalCreditAmt);
        },
        
    },

    mounted() {
        this.$root.loading = true;
        Promise.allSettled([ 
                this.fetchReceivedPayments(), this.fetchUsers(),
                //this.RecordUserActivity(),
            ]).then(() => {
                this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchReceivedPayments() {
            if(!this.filter.dateFrom && !this.filter.dateTo) return Promise.reject();

            let url = `AccountsReports/GetReceivedPayments`;
                url += `?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
                url += this.filter.search ? `&SearchText=${this.filter.search}` : ``;
                url += this.filter.cashier ? `&Cashier=${this.filter.cashier}` : ``;
                url += this.filter.pmode ? `&PaymentMode=${this.filter.pmode}` : ``;

            return this.$http.get(url).then(response => {
                this.payments = response.data;
            }).catch(() => {});
        },

        fetchSearchOnly() {
            this.$root.loading=true;
            if(!this.filter.search) return;

            let url = `AccountsReports/GetReceivedPayments`;
                url += `?Datefrom=${this.filter.dateFrom}&Dateto=${this.filter.dateTo}`;
                url += `&SearchText=${this.filter.search}`;
                url += `&searchonly=${true}`;

            this.$http.get(url).then(response => {
                this.payments = response.data;
                this.$root.loading=false;
            }).catch(() => { this.$root.loading=false; });
        },

        fetchUsers() {

            return this.$http.get(`Admin/GetUsers`).then(response => {
                this.users = response.data;
            }).catch(() => {});
        },

        printCashOutReport() {
            let url = `/reports/accounts-finance/received-payments-report/print-cashout`;
                url += `?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`;
                url += `&search=${this.filter.search}`;

            window.open(url,
             '_blank', 
             `ReportPrint`, 
             "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printPaymentBillReport() {
            let url = `/reports/accounts-finance/received-payments-report/print-bill-payment`;
                url += `?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`;
                url += `&search=${this.filter.search}`;

            window.open(url,
             '_blank', 
             `ReportPrint`, 
             "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printDepositsReport() {
            let url = `/reports/accounts-finance/received-payments-report/print-deposits`;
                url += `?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`;
                url += `&search=${this.filter.search}`;

            window.open(
                url,
                '_blank', `ReportPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printReceipt(patientId, receiptNo) {

            window.open(
                `/billing/receipt-invoice/print/${patientId}/${receiptNo}`, 
                '_blank', `ReceiptCash`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printPOSSalesReceipt(receiptNo) {
            window.open(`/sales/sale-receipt/${receiptNo}`, 'ReceiptPreview');
},  printDepositReceipt(patientId, receiptNo) {

window.open(
    `/billing/receipt-deposit/print-single?PatientID=${patientId}&ReceiptNo=${receiptNo}`, 
    '_blank', 
    `ReceiptDeposit`, 
    "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
},

        printDepositDetailsReceipt(patientId, receiptNo) {

            window.open(
                `/reports/accounts-finance/deposit-details/print/${patientId}/${receiptNo}`, 
                '_blank', 
                `ReceiptDepositDetails`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },

        printReceivedPaymentReport() {
            let url = `/reports/accounts-finance/received-payments-report/print`;
                url += `?dateFrom=${this.filter.dateFrom}&dateTo=${this.filter.dateTo}`;
                url += this.filter.cashier ? `&Cashier=${this.filter.cashier}` : ``;
                url += this.filter.pmode ? `&PaymentMode=${this.filter.pmode}` : ``;
                url += this.filter.search ? `&search=${this.filter.search}` : ``;

            window.open(
                url,
                '_blank', `ReportPrint`, 
                "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
        RecordUserActivity() {
          this.userActivityModels.userActivity="Page Access: "+this.$root.username+": Successfully Accessed Received Payment Report";
          this.userActivityModels.userHostAddress=window.location.host;
          this.userActivityModels.userHostAddress=window.location.hostname;
          
          this.$root.loading = true;
                this.$http.post(`Admin/RecordUserActivity`, this.userActivityModels).then(response => {
                     
                  this.responsemsg= response.data;
                    this.$root.loading = false;
                 }).catch(() => { this.$root.loading = false; });

          
        },
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link 
                    :to="{ name: `reports.accounts-finance.index` }">
                        Accounts & Finance Reports</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Received Payments Report</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Received Payments report</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap content-start overflow-auto" style="height:78vh;">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search"
                    @keydown.enter="fetchSearchOnly" 
                    placeholder="press enter to search only"
                    id="grid-search" class="input-control input-sm text-xs"> 
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="$root.checkAuth('AccessOldData')
                ">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom"
                    id="grid-date-from" class="input-control input-sm text-xs" >
              </div> 
              <div class="md:w-1/6 sm:w-full p-tiny"  v-if="!$root.checkAuth('AccessOldData')">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" :min="$root.minFilterDate"
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-cashier" class="label-control">Cashier:</label>
                  <v-select class="bg-white text-xs" 
                    v-model="filter.cashier"
                    label="userName"
                    :options="payments.cashiers" 
                    :reduce="user => user.userName" 
                  />
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-cashier" class="label-control">P Mode:</label>
                  <v-select class="bg-white text-xs" 
                    v-model="filter.pmode"
                    :options="payments.pMode"
                    label="mode" 
                    :reduce="pMode => pMode.mode" 
                  />
              </div>
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="() => {
                        $root.loading=true;
                        fetchReceivedPayments().then(() => {
                            $root.loading=false;
                        }).catch(() => { $root.loading=false; });
                    }">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
            <div class="w-full p-tiny">
                <h5 class="font-semibold text-base">Payments Against Bills</h5>
            </div>
            <table class="table table-hover" id="receivedPaymentsReport">
                <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/12">Time(d-m-y)</th>
                          <th class="p-tiny w-1/6">Patient</th>
                          <th class="p-tiny flex-1">IPFile No</th>
                          <th class="p-tiny flex-1">OPFile No</th>
                          <th class="p-tiny flex-1">Receipt No</th>
                          <th class="p-tiny flex-1">Mode</th>
                          <th class="p-tiny flex-1">Paid</th>
                          <th class="p-tiny flex-1">Reversed</th>
                          <th class="p-tiny flex-1">Receipt</th>
                          <th class="p-tiny w-1/6">Memo</th>
                          <th class="p-tiny flex-1">Username</th>
                          <th class="p-tiny flex-1">Action</th>
                      </tr>
                </thead>
                <tfoot>
                    <tr class="w-full flex">
                        <th class="p-tiny w-1/4"></th>
                        <th class="p-tiny w-1/4">
                            Paid Amt: {{ totalPaidAmt | numberFormat }}</th>
                        <th class="p-tiny w-1/4">
                            Credit Amt: {{ totalCreditAmt | numberFormat }}</th>
                        <th class="p-tiny w-1/4">
                            Receipt Amt: {{ totalReceiptAmt | numberFormat }}</th>
                    </tr>
                </tfoot>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" v-for="(payment, idx) in payments.billPaymentsReport" 
                        :key="idx">
                        <td class="p-tiny w-1/12">{{ payment.sysDate }}</td>
                        <td class="p-tiny w-1/6">{{ payment.patient }}</td>
                        <td class="p-tiny flex-1">{{ payment.ipfileno || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.opfileno || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.receipt_No || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.mode }}</td>
                        <td class="p-tiny flex-1">{{ payment.amount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.creditAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.receiptAmount | numberFormat }}</td>
                        <td class="p-tiny w-1/6">{{ payment.refNo || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.userName }}</td>
                        <td class="p-tiny flex-1">
                          <button 
                            class="btn-sm btn-info text-xs rounded" 
                            @click.prevent="printReceipt(payment.patienT_ID, payment.receipt_No)">
                                <i class="fa fa-print"></i> Receipt</button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="w-full p-tiny">
                <h5 class="font-semibold text-base">Deposits Received</h5>
            </div>
            <table class="table table-hover" id="receivedDepositsReport">
                <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/12">Date</th>
                          <th class="p-tiny w-1/6">Patient</th>
                          <th class="p-tiny flex-1">IPFile No</th>
                          <th class="p-tiny flex-1">OPFile No</th>
                          <th class="p-tiny flex-1">Receipt No</th>
                          <th class="p-tiny flex-1">Type</th>
                          <th class="p-tiny flex-1">Mode</th>
                          <th class="p-tiny flex-1">User</th>
                          <th class="p-tiny flex-1">Amount</th>
                          <th class="p-tiny flex-1">Allocated</th>
                          <th class="p-tiny flex-1">Un-allocated</th>
                          <th class="p-tiny w-1/6">Memo</th>
                          <th class="p-tiny w-1/12">Print</th>
                      </tr>
                </thead>
                <tfoot>
                    <tr class="w-full flex">
                        <th colspan="3" class="p-tiny flex-1"></th>
                        <th class="p-tiny flex-1">
                            Total Amt: {{ totalDepositAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Total Allocated: {{ totalAllocatedAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Un-allocated: {{ totalUnallocatedAmt | numberFormat }}</th>
                    </tr>
                </tfoot>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" 
                        v-for="(payment, idx) in payments.depositsReport" :key="idx">
                        <td class="p-tiny w-1/12">{{ payment.trxDate | dateFormat }}</td>
                        <td class="p-tiny w-1/6">{{ payment.names }}</td>
                        <td class="p-tiny flex-1">{{ payment.ipfileno || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.opfileno || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.receiptNo }}</td>
                        <td class="p-tiny flex-1">{{ payment.paymentType }}</td>
                        <td class="p-tiny flex-1">{{ payment.mode }}</td>
                        <td class="p-tiny flex-1">{{ payment.userName || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.depositAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.amountAllocated | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.unAllocatedAmount | numberFormat }}</td>
                        <td class="p-tiny w-1/6">{{ payment.trxMemo }}</td>
                        <td class="p-tiny w-1/12">
                            <button
                                @click.prevent="printDepositReceipt(payment.patientID, payment.receiptNo)" 
                                class="btn-sm btn-info text-xs rounded m-px">
                                    <i class="fa fa-print"></i> Receipt</button>
                            <button 
                                class="btn-sm btn-primary text-xs rounded m-px" 
                                @click.prevent="printDepositDetailsReceipt(payment.patientID, payment.receiptNo)">
                                    <i class="fa fa-print"></i> Details</button>
                        </td>
                    </tr>
                </tbody>
            </table> <div class="w-full p-tiny" v-if="$root.checkAuth(`ViewPOSSalesReport`)">
                <h5 class="font-semibold text-base">POS Sales Payment</h5> 
            </div>
            <table class="table table-hover" id="receivedDepositsReport" v-if="$root.checkAuth(`ViewPOSSalesReport`)">
                <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/12">Date</th>
                          <th class="p-tiny w-1/6">Receipt No</th>
                          <th class="p-tiny flex-1">Sales No</th>
                          <th class="p-tiny flex-1">Customer Name</th>
                          <th class="p-tiny flex-1">Ref</th>
                          <th class="p-tiny flex-1">Mode</th>
                          <th class="p-tiny flex-1">User</th>
                          <th class="p-tiny flex-1">Amount</th>
                          <th class="p-tiny flex-1">Paid</th>
                          <th class="p-tiny flex-1">Balance</th>
                          <!-- <th class="p-tiny w-1/6">Memo</th> -->
                          <th class="p-tiny w-1/12">Print</th>
                      </tr>
                </thead>
                <tfoot>
                    <tr class="w-full flex">
                        <th colspan="3" class="p-tiny flex-1"></th>
                        <th class="p-tiny flex-1">
                            Total Amt: {{ totalSalesAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Total Paid: {{ totalSalesPaidAmt | numberFormat }}</th>
                        <th class="p-tiny flex-1">
                            Balance: {{ totalSalesbalanceAmt | numberFormat }}</th>
                    </tr>
                </tfoot>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" 
                        v-for="(payment, idx) in payments.salesReport" :key="idx">
                        <td class="p-tiny w-1/12">{{ payment.txnDate | dateFormat }}</td>
                        <td class="p-tiny w-1/6">{{ payment.receiptNo }}</td>
                        <td class="p-tiny flex-1">{{ payment.billNo || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.customerName || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.ref }}</td>
                         <td class="p-tiny flex-1">{{ payment.mode }}</td>
                        <td class="p-tiny flex-1">{{ payment.userName || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.totalAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.paidAmount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.balance | numberFormat }}</td>
                          <!-- <td class="p-tiny w-1/6">{{ payment.trxMemo }}</td> -->
                        <td class="p-tiny w-1/12">
                            <button
                                @click.prevent="printPOSSalesReceipt(payment.receiptNo)" 
                                class="btn-sm btn-info text-xs rounded m-px">
                                    <i class="fa fa-print"></i> Receipt</button>
                          
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="w-full p-tiny">
                <h5 class="font-semibold">Approved Cash Out</h5>
            </div>
            <table class="table table-hover" id="approvedCashOutReport">
                <thead class="bg-blue-500 text-xs text-white">
                      <tr class="w-full flex">
                          <th class="p-tiny w-1/6">Authorized By</th>
                          <th class="p-tiny w-1/6">Received By</th>
                          <th class="p-tiny w-1/6">Item</th>
                          <th class="p-tiny w-1/6">Memo</th>
                          <th class="p-tiny w-1/12">Qty</th>
                          <th class="p-tiny w-1/6">Username</th>
                          <th class="p-tiny w-1/6">Approved By</th>
                          <th class="p-tiny w-1/6">Amount</th>
                      </tr>
                </thead>
                <tfoot>
                    <tr class="w-full flex">
                        <th class="w-1/2"></th>
                        <th class="w-1/2 text-right uppercase">Total Amount: 
                            {{ totalCashOut | numberFormat }}</th>
                    </tr>
                </tfoot>
                <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" v-for="(payment, idx) in payments.cashReport" :key="idx">
                        <td class="p-tiny w-1/6">{{ payment.authorisedBy }}</td>
                        <td class="p-tiny w-1/6">{{ payment.receivedBy }}</td>
                        <td class="p-tiny w-1/6">{{ payment.item }}</td>
                        <td class="p-tiny w-1/6">{{ payment.memo || `-` }}</td>
                        <td class="p-tiny w-1/12">{{ payment.quantity }}</td>
                        <td class="p-tiny w-1/6">{{ payment.userName || `-` }}</td>
                        <td class="p-tiny w-1/6">{{ payment.approvedBy || `-` }}</td>
                        <td class="p-tiny w-1/6">{{ payment.amount | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="w-full p-1 text-center">
                <h5 class="font-bold text-base">Total Periodic Collections</h5>
            </div>
            <div class="w-full flex flex-col md:flex-row bg-gray-300 p-1 my-1">
                <div class="flex-1">
                    <h5 class="font-semibold text-base">
                        Received Amount: {{ totalReceivedAmount | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-semibold text-base">
                        Credit Amount: {{ totalCreditAmt | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-semibold text-base">Cash Out: 
                        {{ totalCashOut | numberFormat }}</h5>
                </div>
                <div class="flex-1">
                    <h5 class="font-semibold text-base">Till Amount: 
                        {{ tillAmount | numberFormat }}</h5>
                </div>
            </div>
        </div>
        </template>
        <template v-slot:card-footer>
            <div class="w-full text-right">
                <button class="btn-sm btn-primary text-xs rounded" 
                    @click.prevent="printReceivedPaymentReport">
                        <i class="fa fa-print"></i> Print</button>
            </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>
